import C from "../constants";

export default function admin(state = {}, payload) {
  let { type, key, data } = payload;
  switch (type) {
    case C.UPDATE_ADMIN_INPUT:
      return { ...state, [key]: data };
    default:
      return state;
  }
}
